import { useState } from "react";
import { Loader2 } from "lucide-react";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "./ui/alert-dialog";

// Standard deletion confirmation: closes only when onConfirm resolves truthy (server confirmed).
export function ConfirmDelete({ open, title, message, confirmLabel = "Excluir definitivamente", onConfirm, onClose, testid = "confirm-delete" }) {
  const [busy, setBusy] = useState(false);
  const go = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { if (await onConfirm()) onClose(); } finally { setBusy(false); }
  };
  return (
    <AlertDialog open={open} onOpenChange={(o) => !o && !busy && onClose()}>
      <AlertDialogContent data-testid={`${testid}-dialog`}>
        <AlertDialogHeader>
          <AlertDialogTitle data-testid={`${testid}-title`}>{title}</AlertDialogTitle>
          <AlertDialogDescription data-testid={`${testid}-message`}>{message}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={busy} data-testid={`${testid}-cancel`}>Cancelar</AlertDialogCancel>
          <AlertDialogAction disabled={busy} onClick={go} className="bg-rose-600 hover:bg-rose-700" data-testid={`${testid}-confirm`}>
            {busy && <Loader2 className="mr-1.5 h-4 w-4 animate-spin" />}{confirmLabel}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>);
}
